import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { AUTHENTICATED_ENTRY } from "configs/AppConfig";
import { AUTH_PREFIX_PATH } from "configs/AppConfig";

const PublicRoute = () => {
  const { token } = useSelector((state) => state.auth);
  const location = useLocation();

  const authPrefix = AUTH_PREFIX_PATH || "/auth";
  if (token && location.pathname.startsWith(authPrefix)) {
    return <Navigate to={AUTHENTICATED_ENTRY} replace />;
  }

  return <Outlet />;
};

export default PublicRoute;
